<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <button type="button" class="btn btn-primary" @click="onClick()">
      {{ $t("Backward") }}
    </button>
  </div>
</template>
<script>
import { usePreview3DStore } from "@/stores/modules/preview3D";
import { mapState, mapActions } from "pinia";

export default {
  computed: { ...mapState(usePreview3DStore, ["get3DPreviewId"]) },
  methods: {
    onClick: function () {
      jQuery("#" + this.get3DPreviewId + " iframe")
        .get(0)
        .contentWindow.postMessage(
          JSON.stringify({
            animation_click: "backward"
          }),
          "*"
        );
    }
  }
};
</script>
